import { Heading as RadixHeading } from '@radix-ui/themes'
import { forwardRef } from 'react'
import type { ComponentPropsWithoutRef } from 'react'

type HeadingProps = ComponentPropsWithoutRef<typeof RadixHeading>

export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className = '', ...props }, ref) => {
    return <RadixHeading className={className} ref={ref} {...props} />
  }
)

Heading.displayName = 'Heading'
